import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import './preloader.scss';
import { useAnimationContext } from '../../AnimationContext';

const Preloader = () => {
  const [progress, setProgress] = useState(0);
  const overlayRef = useRef(null);
  const counterRef = useRef(null);
  //const logoRef = useRef(null);

  const { setIsPreloaderComplete } = useAnimationContext(); // Use the context

  useEffect(() => {
    const handleLoad = () => {
      setProgress(80);
      // Use GSAP to animate the overlay and counter sliding out
      let currentProgress = 70;
      const interval = setInterval(() => {
        currentProgress += 1; // Increment progress
        setProgress(currentProgress);
    
        if (currentProgress >= 100) {
          clearInterval(interval); // Stop the interval once progress reaches 100
    
          // Trigger GSAP animations after progress reaches 100
            gsap.to([counterRef.current], {
                delay: 0.5,
                opacity: 0,
                duration: 2,
                ease: "power2.inOut",
            });
            /* gsap.to([logoRef.current], {
                delay: 0.5,
                fill: "#101010",
                height: "70px",
                width: "70px",
                duration: 3,
                ease: "power2.inOut",
            });  */
            gsap.to(".bar", 1.5, {
                delay: 1,
                height: 0,
                ease: "power4.inOut",
                stagger: {
                amount: 0.5,
                },
                onComplete: () => {
                    overlayRef.current.style.display = "none";
                    counterRef.current.style.display = "none";
                    //logoRef.current.style.display = "none";

                    setIsPreloaderComplete(true); // Update the global state
                },
            });
        }
      }, 50); 
    };

    const handleProgress = (event) => {
        if (event.lengthComputable) {
          const loadedPercentage = (event.loaded / event.total) * 100;
          // Calculate progress based on 80 being the full load
          const progressValue = Math.round((loadedPercentage / 100) * 70);
          setProgress(progressValue);
        }
      };

    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', handleLoad);
    xhr.addEventListener('progress', handleProgress);
    xhr.open('GET', window.location.href);
    xhr.send();

    return () => {
      xhr.removeEventListener('load', handleLoad);
      xhr.removeEventListener('progress', handleProgress);
    };
  }, [setIsPreloaderComplete]);

  return (
    <>
        <div ref={counterRef} className="counter">{`${progress}%`}</div>
        <div ref={overlayRef} className="overlay">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
        </div>
    </>
  );
};

export default Preloader;